import { Header } from './Header'

import { useGetDemand } from '@/hooks/useGetDemand'
import { twMerge } from '../../styles/tailwindMergeConfig'

import { Skeleton } from './Skeleton'
import { TabsLeft } from './TabsLeft'
import { TabsRight } from './TabsRight'
import { ReportOptionsProvider } from '@/hooks/reports/useReportOptions'
import { useSearchParams } from 'react-router-dom'

export function DemandReports() {
  const { data, isLoading, isError } = useGetDemand()
  const [searchParams] = useSearchParams()
  const action = searchParams.get('action')
  if (isLoading || isError) {
    return <Skeleton isLoading={isLoading} />
  }

  if (data) {
    return (
      <ReportOptionsProvider>
      <main className="flex size-full flex-col items-center overflow-auto px-7 pb-10 pt-6 font-mono lg:h-screen">
        <Header action={action as 'refuse' | 'report'} />
          <section
            className={twMerge(
              'lg:flex-row',
              'mt-6 flex h-[calc(100vh-11.6rem)] w-full max-w-screen-xl flex-col gap-6 '
            )}
          >
            <TabsLeft />
            <TabsRight />
          </section>
      </main>
      </ReportOptionsProvider>
    )
  }
}
